import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  loader: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default useStyles;
